import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Headline.css';
import Unsplash, { toJson } from 'unsplash-js';
import { headlinesArr, mobileHeadlinesArr } from './constants/Headlines';
import HardwareKeyboardArrayDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
const unsplash = new Unsplash({
  applicationId: "2b810b32df573837547d33967b75297ac324e36ec33992cf9e3d0a1334e6fecf",
});

const mapStateToProps = (state) => {
  return {
    fonts: state.fonts,
  }
}
class Headline extends Component {
  constructor(props) {
    super(props);

    // set a random headline
    let randomHeadline = headlinesArr[Math.floor(Math.random() * headlinesArr.length)];
    if (window.innerWidth < 768) {
      randomHeadline = mobileHeadlinesArr[Math.floor(Math.random() * mobileHeadlinesArr.length)];
    }
    this.state = {
      backgroundImage: undefined,
      photographer: undefined,
      headlineText: randomHeadline
    }
  }

  componentDidMount() {
    var intervalFunc = setInterval(this.updateMoment, 60 * 1000);
    this.setState({intervalFunc: intervalFunc});
    unsplash.photos.getRandomPhoto({
      query: "landscape",
      orientation: 'landscape',
    })
    .then(toJson)
    .then((json) => {
      this.setState({
        backgroundImage: json.urls.regular,
        photographer: json.user
      });
    });
  }

  render() {
    const {
      backgroundImage,
      photographer,
    } = this.state;

    const {
      fonts,
    } = this.props;

    const {
      primary,
      secondary,
    } = fonts;

    return (
      <div className="headline-wrapper">
        <div className="headline-background"
        style={{
          backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'url("https://i.imgur.com/hMusfS3.jpg")',
        }}></div>
        <div className="headline-text-wrapper">
          <div className="header-font"
            style={{
              'fontFamily': primary.name,
              'marginBottom': 20
            }}>
            <div className="primary-name long-shadow">
              {primary.name}
            </div>
          </div>
          <div className="headline-subheader"
            style={{
              'fontFamily': secondary.name,
            }}>
            Paired with <span className="bold">{secondary.name}.</span> This is a sample secondary header to show what these fonts might look like together on the top of your site. Scroll down to see these fonts work together in action. 
          </div>
          <div className="headline-scroll-down-icon-container">
            <HardwareKeyboardArrayDown className="headline-scroll-down-icon" />
          </div>
        </div>
        {photographer
          ? <div className="unsplash-attribution"
            style={{ 'fontFamily': secondary.name }}>
              Photo by <a href={'https://unsplash.com/@' + photographer.username + '?utm_source=mixfont&utm_medium=referral&utm_campaign=api-credit'}
                target="_blank">{photographer.name}</a>
              &nbsp;/&nbsp;
                <a href='https://unsplash.com/'
                  target="_blank">Unsplash</a>
            </div>
          : null}
      </div>
    )
  }
}

export default Headline = connect(mapStateToProps, undefined)(Headline);



// WEBPACK FOOTER //
// ./src/components/generator/Headline.jsx